import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'src.components.IdealUserPopUp.header',
    defaultMessage: 'Need more time?',
  },
  descriptionOne: {
    id: 'src.components.IdealUserPopUp.descriptionOne',
    defaultMessage: 'Looks like you’ve been gone for a while and will be logged out soon. We’ve automatically saved your claim progress so you can come back to it later, or just click ’Okay’ below to stay logged in.',
  },
  descriptionTwo: {
    id: 'src.components.IdealUserPopUp.descriptionTwo',
    defaultMessage: 'Looks like you’ve been gone for a while and will be logged out soon. No worries though, just click ’Okay’ below to stay logged in.',
  },
  descriptionThree: {
    id: 'src.components.IdealUserPopUp.descriptionThree',
    defaultMessage: 'Looks like you’ve been gone for a while and will be logged out soon. If you log out now, your progress won’t be saved or click “Okay” below to stay logged in and continue.',
  },
  okay: {
    id: 'src.components.IdealUserPopUp.okay',
    defaultMessage: 'Okay',
  },
  logout: {
    id: 'src.components.IdealUserPopUp.logout',
    defaultMessage: 'Log out',
  },
});
